'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useMemo, Fragment } from 'react';
import { MANIFEST_FONTS } from '../../../core/manifest/fonts.js';
import { isNonNullish } from '../../../core/utilities/is.utils.js';
import { getSameKeyValueMapForManifest, manifestResolve } from '../../../core/utilities/manifest.utils.js';
import { useSwanHeadConfig } from './head.hook.js';
import { SwanPathTypeEnum, SwanAssetFolders } from '../../../core/types/enums.js';
import { SWAN_BASE_CDN_URL } from '../../../core/constants/domains.js';

var r;
const SWAN_FONT_KEY_MAP = getSameKeyValueMapForManifest(MANIFEST_FONTS);
var SwanFontNameEnum;
(r = SwanFontNameEnum || (SwanFontNameEnum = {})).Graphik = "Graphik", r.GraphikMedium = "GraphikMedium", r.GraphikRegular = "GraphikRegular", r.Tiempos = "Tiempos", r.TiemposRegular = "TiemposRegular", r.Primary = "Graphik", r.PrimaryBold = "GraphikMedium", r.PrimaryRegular = "GraphikRegular", r.Secondary = "Tiempos", r.SecondaryRegular = "TiemposRegular";
const SwanFonts = ({ fontNames: r, swanPathType: n, swanBaseUrl: i, swanTenant: l, swanLocale: s, renderWith: f = Fragment, renderStyleContentAsChildren: m })=>{
    let { swanBaseUrl: p, swanPathType: g } = useSwanHeadConfig(i, n, l, s), [c, h] = useMemo(()=>getSwanFontRenderConfig(r || void 0, g, p), [
        r,
        g,
        p
    ]);
    return jsxs(f, {
        children: [
            c.map((r)=>jsx("link", {
                    rel: "preload",
                    crossOrigin: "anonymous",
                    as: "font",
                    href: r
                }, r)),
            m ? jsx("style", {
                type: "text/css",
                children: h
            }, "swan-font-config-children") : jsx("style", {
                type: "text/css",
                dangerouslySetInnerHTML: {
                    __html: h
                }
            }, "swan-font-config-inner-html")
        ]
    });
};
function getSwanFontUrl(r, e, t) {
    return manifestResolve(MANIFEST_FONTS, r, SwanAssetFolders.FONTS, e, t);
}
function getSwanFontRenderConfig(r = [
    "Graphik"
], e = SwanPathTypeEnum.hashed, t = SWAN_BASE_CDN_URL) {
    return [
        r.flatMap((r)=>getPreLoadUrlsForFontName(r, e, t)).filter(isNonNullish),
        r.map((r)=>getSwanFontStyleConfig(r, e, t)).join('\n')
    ];
}
function getPreLoadUrlsForFontName(r, e, t) {
    switch(r){
        case "Graphik":
            return [
                "GraphikMedium",
                "GraphikRegular"
            ].flatMap((r)=>getPreLoadUrlsForFontName(r, e, t));
        case "GraphikMedium":
            return [
                getSwanFontUrl(SWAN_FONT_KEY_MAP.graphicMedium2, e, t)
            ];
        case "GraphikRegular":
            return [
                getSwanFontUrl(SWAN_FONT_KEY_MAP.graphicRegular2, e, t)
            ];
        case "Tiempos":
            return [
                "TiemposRegular"
            ].flatMap((r)=>getPreLoadUrlsForFontName(r, e, t));
        case "TiemposRegular":
            return [
                getSwanFontUrl(SWAN_FONT_KEY_MAP.tiemposRegular2, e, t)
            ];
        default:
            return [
                null
            ];
    }
}
function getSwanFontStyleConfig(r, e, t) {
    let fontUrlForKey = (r)=>getSwanFontUrl(r, e, t) || '';
    switch(r){
        case "Graphik":
            return [
                "GraphikMedium",
                "GraphikRegular"
            ].map((r)=>getSwanFontStyleConfig(r, e, t)).join('\n');
        case "Tiempos":
            return [
                "TiemposRegular"
            ].map((r)=>getSwanFontStyleConfig(r, e, t)).join('\n');
        case "GraphikMedium":
            return `
        @font-face {
          font-family: 'Graphik';
          font-stretch: normal;
          font-style: normal;
          font-weight: 700;
          font-display: swap;
          src: url('${fontUrlForKey(SWAN_FONT_KEY_MAP.graphicMedium2)}') format('woff2'),
            url('${fontUrlForKey(SWAN_FONT_KEY_MAP.graphicMedium)}') format('woff');
        }`;
        case "GraphikRegular":
            return `
      @font-face {
        font-family: 'Graphik';
        font-stretch: normal;
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('${fontUrlForKey(SWAN_FONT_KEY_MAP.graphicRegular2)}') format('woff2'),
          url('${fontUrlForKey(SWAN_FONT_KEY_MAP.graphicRegular)}') format('woff');
      }`;
        case "TiemposRegular":
            return `
      @font-face {
        font-family: 'Tiempos';
        font-stretch: normal;
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('${fontUrlForKey(SWAN_FONT_KEY_MAP.tiemposRegular2)}') format('woff2');
      }
      `;
        default:
            return "";
    }
}

export { SWAN_FONT_KEY_MAP, SwanFontNameEnum, SwanFonts, getSwanFontRenderConfig, getSwanFontUrl };
